/**
 * Help §5.2 — The main screen (`dashboard/DashboardView.tsx`, `shell/nav-items.ts`,
 * `shell/Sidebar.tsx`).
 */
import { helpSectionMeta } from '../help-sections.js';
import {
  Btn,
  Bullets,
  Callout,
  HelpSectionCard,
  Li,
  P,
  Screen,
  Shot,
  SubHead,
} from '../HelpPrimitives.js';

export function MainScreen(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('main-screen')}>
      <Shot
        slug="portfolio"
        caption="The Project Portfolio: the sidebar menu, the three count cards and the project list."
      />

      <SubHead>The left-hand menu</SubHead>
      <Bullets>
        <Li>
          <Btn>Dashboard</Btn> and <Btn>Projects</Btn> — both open the same{' '}
          <Screen>Project Portfolio</Screen> screen.
        </Li>
        <Li>
          <Btn>Inbox</Btn> — incoming client emails.
        </Li>
        <Li>
          <Btn>Clients</Btn> — your client and contact directory.
        </Li>
        <Li>
          <Btn>Research</Btn> — company research workspace.
        </Li>
        <Li>
          <Btn>Settings</Btn> — admin-only.
        </Li>
      </Bullets>
      <P>
        <Btn>Connect Outlook</Btn>, <Btn>Help</Btn> (this guide) and <Btn>Log out</Btn> live at the
        bottom of the sidebar, not in the main menu list.
      </P>

      <SubHead>The three count cards</SubHead>
      <P>
        <Btn>Awaiting Kick-off</Btn>, <Btn>In Progress</Btn> and <Btn>Launched</Btn> — how many
        projects sit at each point of the process.
      </P>

      <SubHead>The project list</SubHead>
      <Bullets>
        <Li>
          <Btn>New Project</Btn> (the “+” button) starts a project by hand.
        </Li>
        <Li>
          The table columns are <Btn>Client / Position</Btn>, <Btn>Stage</Btn>, <Btn>Owner</Btn>,{' '}
          <Btn>Updated</Btn> and <Btn>Actions</Btn> (<Btn>Open ›</Btn>).
        </Li>
        <Li>
          The scope switch flips between <Btn>All</Btn> and <Btn>My Active</Btn>.
        </Li>
      </Bullets>

      <Callout tone="change" title="Changed">
        There is no single search box any more. Instead there are two separate filters —{' '}
        <Btn>Filter by client…</Btn> and <Btn>Filter by position…</Btn> — plus a{' '}
        <Btn>Created from</Btn> / <Btn>Created to</Btn> date range.
      </Callout>
    </HelpSectionCard>
  );
}
